import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { InfiniteDataQueryFnUtils } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { useInfiniteListWithRestore } from '../../../hooks/useInfiniteListWithRestore/useInfiniteListWithRestore';
import { OmitPaginatedEndpointParams } from '../../types';
import { getFindConsultantsKey, getInfiniteConsultantsKey } from './consultants.keys';
import { findConsultants } from './consultants.repository';
import { FindConsultantsOutput, FindConsultantsParams } from './consultants.types';

export const useFindConsultants = (params: FindConsultantsParams, options?: UseDataQueryOptions) =>
  useDataQuery<FindConsultantsOutput | null>(
    {
      queryKey: getFindConsultantsKey(params),
      queryFn: async () => {
        const data = await findConsultants({ 'order[name]': 'ASC', ...params });
        if (!data.ok || !data.data) {
          return null;
        }
        return data.data;
      },
    },
    options,
  );

export const useInfiniteConsultantsList = (
  params: OmitPaginatedEndpointParams<FindConsultantsParams>,
) =>
  useInfiniteListWithRestore({
    limit: 20,
    queryKey: getInfiniteConsultantsKey(params),
    defaultOrderBy: { name: 'ASC' },
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCountAndParams(findConsultants, params),
  });
